// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"inputWrapper--2vzdr","resetIcon":"resetIcon--3pWjH"};